import {FieldValues} from "react-hook-form/dist/types/fields";
import {Control} from "react-hook-form/dist/types";
import {Controller, FieldPath} from "react-hook-form";
import {RegisterOptions} from "react-hook-form/dist/types/validator";
import React, {ReactNode} from "react";

interface BooleanInputProps<TFieldValues extends FieldValues> {
    control: Control<TFieldValues>,
    name: FieldPath<TFieldValues>,
    divClass?: string
    label4true?: string,
    label4false?: string,
    disabled?: boolean,
    radioInline?: boolean,
    inlineChildren?: ReactNode,
    falseChild?: ReactNode,
    trueChild?: ReactNode,
    childrenClass?: string,
    rules?: Omit<RegisterOptions<TFieldValues, FieldPath<TFieldValues>>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'>
}

//https://stackoverflow.com/questions/72657849/how-to-convert-values-from-input-radio-in-boolean-in-react-hook-form
export function BooleanInput<V extends FieldValues>(props: BooleanInputProps<V>) {
    const {control, name, radioInline = false, divClass, inlineChildren, falseChild, trueChild, childrenClass} = props;
    let inline = inlineChildren && radioInline;
    return (
        <Controller
            control={control}
            name={name}
            render={({field: {onChange, onBlur, value, ref}}) => (
                <>
                    {/* PER RADIO BUTTON E OPZIONI IN RIGA */}
                    {inline && <>
                        <div className={`text-sm inline-flex items-center ${divClass ? divClass : ''}`}>
                            <label>
                                <input
                                    type="radio"
                                    onBlur={onBlur} // notify when input is touched
                                    onChange={() => onChange(false)} // send value to hook form
                                    checked={value === false}
                                    ref={ref}
                                />
                                &nbsp;{props.label4false}
                            </label>

                            <label>
                                <input
                                    type="radio"
                                    onBlur={onBlur} // notify when input is touched
                                    onChange={() => onChange(true)} // send value to hook form
                                    checked={value === true}
                                    ref={ref}
                                />
                                &nbsp;{props.label4true}
                            </label>
                        </div>
                        <div className={`inline-flex ${childrenClass ? childrenClass : ''}`}>
                            {inlineChildren}
                        </div>
                    </>
                    }

                    {/* PER RADIO BUTTON E OPZIONI IN "COLONNA" */}
                    {!inline && <>
                        <div className={`text-sm flex flex-col pl-2 h-full justify-evenly w-1/6 ${divClass ? divClass : ''}`}>
                            <label>
                                <input
                                    type="radio"
                                    onBlur={onBlur} // notify when input is touched
                                    onChange={() => onChange(false)} // send value to hook form
                                    checked={value === false}
                                    ref={ref}
                                />
                                &nbsp;{props.label4false}
                            </label>
                            <label className="mt-3">
                                <input
                                    type="radio"
                                    onBlur={onBlur} // notify when input is touched
                                    onChange={() => onChange(true)} // send value to hook form
                                    checked={value === true}
                                    ref={ref}
                                />
                                &nbsp;{props.label4true}
                            </label>
                        </div>
                        <div className={`text-sm flex flex-col pl-2 h-full justify-evenly w-4/6 ${divClass ? divClass : ''}`}>
                            <div className={`flex flex-row ${childrenClass ? childrenClass : ''}`}>{falseChild}</div>
                            <div className={`flex flex-row ${childrenClass ? childrenClass : ''}`}>{trueChild}</div>
                        </div>
                    </>
                    }
                </>


            )}
        />
    );
}

export default BooleanInput;